import {createContext} from 'react';
export const AdminContext=createContext("");
export const SignInContext=createContext("");
export const GoldContext=createContext("");
export const SilverContext=createContext("");
export const ComponentContext=createContext("");
export const NavContext=createContext("");